module.exports = __webpack_public_path__ + "static/portfolio-7-5f9c5742f574629b2f19b6f575758ac2.jpg";